import { User } from './user.model';

export class DistributionList {

  author: User;
  id: number;
  isPublic: boolean = false;
  name: string;
  users: User[] = [];
  workflowIds: number[] = [];

  get userNames(): string {
    return this.users.map((u) => {
      return u.name != null ? u.name : (u.email != null ? u.email.toLowerCase() : '')
    }).join(', ')
  }

  public constructor(init?:Partial<User>) {
    Object.assign(this, init);
  }

  static fromRecord(record) {
    let list = new DistributionList();
    list.author = User.fromRecord(record.author);
    list.id = +record.id;
    list.isPublic = (record.public === true);
    list.name = record.name;
    list.users = record.users.map((u) => User.fromRecord(u));
    list.workflowIds = record.workflow_ids;
    return list;
  }

}


// WEBPACK FOOTER //
// ./src/app/users/distribution-list.model.ts